import { css } from '@emotion/core'

export const feeLoading = css`
  width: 100%;
  height: 100vh;
`
